import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

function init() {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DATADOG_APP_ID,
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_ID,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: process.env.REACT_APP_DATADOG_SITE,
    service: process.env.REACT_APP_DATADOG_SERVICE,
    env: process.env.REACT_APP_DATADOG_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',
    // when we turn on the plugin the data does not show up in the dashboard
    // I think we might need to change our routing in order for it to work, but not necessary as of now
    plugins: [reactPlugin({ router: false })],

    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    enablePrivacyForActionName: true,
    trackSessionAcrossSubdomains: true,

    startSessionReplayRecordingManually: true,
    trackViewsManually: true, // important
    // allowCrossOrigin: true, // critical for iframe communication
  });
  datadogRum.startView('vizzle-main-view');
}

function setUser(user) {
  datadogRum.setUser({
    id: user.id,
    name: user.id,
    districtId: user.externalAccountId,
    districtName: user.district,
  });
  datadogRum.startSessionReplayRecording();
}

function userLogout() {
  datadogRum.clearUser();
  datadogRum.stopSession();
}

export default {
  init,
  setUser,
  userLogout,
};
